<template>
  <div>
    <w-title-bar :title="title" textColor="#000000"></w-title-bar>
    <div id="content" class="about_background content">
      <el-card class="content-position no-padding">
        <img class="center_logo" src="static/al.png" />
        <div class="center_logo_name">{{i18n.app_name}}</div>
        <div class="center_version">{{i18n.version+app_code}}</div>
        <button class="backToHome" @click="checkUpdate">{{i18n.check}}</button>
      </el-card>
    </div>
  </div>
</template>

<script>
import wTitleBar from "@/components/w-titleBar";
export default {
  name: "update",
  components: {
    wTitleBar,
  },
  data() {
    return {
      title: '',
      app_code: '',
    };
  },
  computed: {
    i18n() {
      this.title = this.$t("update.title");
      return this.$t("update");
    },
  },
  mounted() {
    let divContent = document.getElementById("content").clientHeight;
    let screenHeight = document.body.clientHeight;
    document.getElementById("content").style.cssText =
      "height: " + (divContent - 44) + "px;";
    this.getVersion();
  },
  methods: {
    checkUpdate() {
       window.jsBridge.checkUpdate(true);
    },
    getVersion(){
        this.app_code = window.jsBridge.getVersion();
    }
  },
};
</script>

<style>
.about_background {
  background-color: #f6f6f6;
}
.content {
  width: 100vw;
  height: 100vh;
  overflow: scroll;
}
.content-position {
  margin-top: 2%;
  margin-left: 10px;
  margin-right: 10px;
  border-radius: 20px;
}
.no-padding {
  padding: 0px;
}
.el-carousel__item img {
  height: 200px;
  clear: both;
  display: block;
  margin: auto;
}
.center_logo {
  width: 30%;
  height: 30%;
  transform: translate(115%, 3%);
  font-size: 18px;
  vertical-align: middle;
  margin-top: 20%;
}
.center_logo_name {
  text-align: center;
  margin-top: 5%;
  color: #333333;
  font-size: 22px;
  font-weight: 500;
  font-family:PingFang;
}
.center_version {
    text-align: center;
    margin-top: 5%;
    font-family:PingFang;
}
.backToHome {
  width: 100%;
  height: 44px;
  background: url(/static/buttonback.png) no-repeat;
  background-size: 100% 100%;
  border-style: none;
  margin-top: 20%;
  margin-bottom: 10%;
  font-family:PingFang;
  /* transform: translate(2.5%, 0%); */
}
</style>



// WEBPACK FOOTER //
// src/pages/home/update.vue